<template>
  <div class="newsList-wrapper">
    <div class="wap-newsList" :class="columnId && `wap-newsList-${columnId}`">
      <div @click="toWapDetail(item)" class="news-item" v-for="(item, i) in list" :key="i">
        <div class="img bgc-default">
          <img
            :class="isSubjectList ?'subject':'item'"
            :src="item.img_43 || item.img43 || item.topImgUrl || item.img_url || require('@/assets/img/default_4_3.png')"
            :onload="imgLoaded"
            :onerror="errorImg"
            alt
          />
          <template v-if=" item.news_kind == 4 || item.flag == 4 ||  item.has_video ">
            <span class="video-icon"></span>
            <span class="video-duration" v-if="isDuration && (item.video_time) || filter_duration(item)">{{(item.video_time || filter_duration(item) ) | videoDuration}}</span>
          </template>
          <template v-if="item.audio_url">
            <span class="audio-icon"></span>
            <span class="video-duration">{{item.audio_time | videoDuration}}</span>
          </template>
          <!-- <span class="label" :class="{'label-activity': !item.isSubjectEntrance && item.extKind == 2}">{{item | newsKind}}</span> -->
          <span v-show="(item.label)" class="label" :class="`label-class-${item.label}`">{{item.label |labelTxtFilter}}</span>
        </div>

        <div v-if="!isActivity" class="text">
          <div class="title line-3">{{item.title_list || item.news_title}}</div>
          <div class="text-bottom">
            <div class="meta line-1" :style="{opacity:item.source?1:0}">{{item.source}}</div>
            <div v-if="item.happen_time && isHappenTime">{{item.happen_time | formatTime}}</div>
          </div>
        </div>
        <div v-else class="text">
          <div class="title line-3">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
// 新闻列表公用组件
import JumpDetailHook from '@/mixins/jumpDetailHook.js';


export default {
  name: "NewsList",
  data() {
    return {
      imgLoaded: `this.style.background = 'none'`,
      errorImg: 'this.src="' + require("@/assets/img/default_4_3.png") + '"',
    };
  },
  mixins:[JumpDetailHook],
  props: {
    list: {
      //数据
      type: Array,
      default: () => []
    },
    type: {
      // 用于新闻详情页下一篇类型 1-信息流列表 2-专题列表 3-栏目列表
      type: Number,
      default: null
    },
    columnId: {
      type: String,
      default: null
    },
    isSubjectList: {
      type: Boolean,
      default: false
    },
    isActivity: {
      type: Boolean,
      default: false
    },
    isVideoNews:{
      type:Boolean,
      default:false
    },
    isHappenTime:{
      type:Boolean,
      default:true
    },
    isDuration:{
      type:Boolean,
      default:true
    }
  },
  methods:{
    filter_duration(v){
      if(!v.sub_list) return false;
      if(Array.isArray(v.sub_list)){
      let arr =  v.sub_list.filter(v=>Boolean(v.video_time))
      if(!arr.length){
        return false
      }
      return arr[0].video_time
      }
      return false
    }
  }
};
</script>
<style lang="less" scoped>
.newsList-wrapper {
  .wap-newsList {
    padding: 4.4vw 4vw 0;
    &.wap-newsList-208 {
      .news-item .text {
        .title {
          font-size: 4.815vw;
          line-height: 6.667vw;
        }
        .meta {
          font-size: 3.241vw;
        }
      }
    }
    .news-item {
      width: 100%;
      padding-bottom: 4.267vw;
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 4.267vw;
      .img {
        width: 32.533vw;
        height: 24.4vw;
        float: left;
        position: relative;
        .video-icon {
          position: absolute;
          width: 6.667vw;
          height: 6.667vw;
          background: url("../../assets/img/video_play.png") center no-repeat;
          background-size: cover;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .audio-icon {
          position: absolute;
          width: 6.667vw;
          height: 6.667vw;
          background: url("../../assets/img/hk-audio-icon.png") center no-repeat;
          background-size: cover;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .video-duration {
          padding: 0.267vw 0.533vw;
          color: #fff;
          font-size: 1.6vw;
          position: absolute;
          bottom: 3.998px;
          left: 0.533vw;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 0.533vw;
        }
        .label {
          padding: 1px 4px;
          font-size: 3.2vw;
          left: 1.6vw;
          top: 1.6vw;
        
        }
        img{
          &.item{
          object-fit: cover;
          }
          &.subject{
          height: auto !important;
          }
        }
      }
      .text {
        margin-left: 36.667vw;
        height: 24.4vw;
        .title {
          font-size: 4.533vw;
          line-height: 6.4vw;
          height: 17.8vw;
          margin-bottom: 3vw;
          overflow: hidden;
          color: #333333;
        }
        .text-bottom {
          color: #999999;
          font-size: 3.2vw;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .meta {
          //    line-height: 3.2vw;
          margin-top: 1.067vw;
          &.line-1 {
            width: 22vw;
          }
        }
      }
    }
  }
}
</style>